import { Action } from '@ngrx/store';
import { IFormStatus } from '../../../commons';

export enum FormStatusActionTypes {
  LoadInitFormStatusState = '[FormStatus] Load Initial FormStatus State',
  LoadFormStatusStateFail = '[FormStatus] Load FormStatus State Fail',
  FormStatusScreenErrorReset = '[FormStatus] FormStatus Screen Error Reset',

  LoadOpenFormCGState = '[FormStatus] Load Open FormCG State',
  LoadOpenFormCGStateSuccess = '[FormStatus] Load Open FormCG State Success',
  LoadClosedFormCGState = '[FormStatus] Load Closed FormCG State',
  LoadClosedFormCGStateSuccess = '[FormStatus] Load Closed FormCG State Success',

  LoadOpenFormPPState = '[FormStatus] Load Open FormPP State',
  LoadOpenFormPPStateSuccess = '[FormStatus] Load Open FormPP State Success',
  LoadClosedFormPPState = '[FormStatus] Load Closed FormPP State',
  LoadClosedFormPPStateSuccess = '[FormStatus] Load Closed FormPP State Success',

  LoadOpenFormESState = '[FormStatus] Load Open FormES State',
  LoadOpenFormESStateSuccess = '[FormStatus] Load Open FormES State Success',
  LoadClosedFormESState = '[FormStatus] Load Closed FormES State',
  LoadClosedFormESStateSuccess = '[FormStatus] Load Closed FormES State Success',

  CloseRequest = '[FormStatus] Close selected requests',
  ComposeEmail = '[FormStatus] Compose email for selected requests',

}


export class LoadInitFormStatusState implements Action {
  readonly type = FormStatusActionTypes.LoadInitFormStatusState;
}

export class LoadFormStatusStateFail implements Action {
  readonly type = FormStatusActionTypes.LoadFormStatusStateFail;
  constructor(public payload: any) { }
}

export class FormStatusScreenErrorReset implements Action {
  readonly type = FormStatusActionTypes.FormStatusScreenErrorReset;
}

// formCG
export class LoadOpenFormCGState implements Action {
  readonly type = FormStatusActionTypes.LoadOpenFormCGState;
}

export class LoadOpenFormCGStateSuccess implements Action {
  readonly type = FormStatusActionTypes.LoadOpenFormCGStateSuccess;
  constructor(public payload: IFormStatus) { }
}

export class LoadClosedFormCGState implements Action {
  readonly type = FormStatusActionTypes.LoadClosedFormCGState;
}

export class LoadClosedFormCGStateSuccess implements Action {
  readonly type = FormStatusActionTypes.LoadClosedFormCGStateSuccess;
  constructor(public payload: IFormStatus) { }
}

// formPP
export class LoadOpenFormPPState implements Action {
  readonly type = FormStatusActionTypes.LoadOpenFormPPState;
}

export class LoadOpenFormPPStateSuccess implements Action {
  readonly type = FormStatusActionTypes.LoadOpenFormPPStateSuccess;
  constructor(public payload: IFormStatus) { }
}
export class LoadClosedFormPPState implements Action {
  readonly type = FormStatusActionTypes.LoadClosedFormPPState;
}

export class LoadClosedFormPPStateSuccess implements Action {
  readonly type = FormStatusActionTypes.LoadClosedFormPPStateSuccess;
  constructor(public payload: IFormStatus) { }
}

// formES
export class LoadOpenFormESState implements Action {
  readonly type = FormStatusActionTypes.LoadOpenFormESState;
}

export class LoadOpenFormESStateSuccess implements Action {
  readonly type = FormStatusActionTypes.LoadOpenFormESStateSuccess;
  constructor(public payload: IFormStatus) { }
}

export class LoadClosedFormESState implements Action {
  readonly type = FormStatusActionTypes.LoadClosedFormESState;
}

export class LoadClosedFormESStateSuccess implements Action {
  readonly type = FormStatusActionTypes.LoadClosedFormESStateSuccess;
  constructor(public payload: IFormStatus) { }
}

// other
export class CloseRequest implements Action {
  readonly type = FormStatusActionTypes.CloseRequest;
  constructor(public data: any) { }
}

export class ComposeEmail implements Action {
  readonly type = FormStatusActionTypes.ComposeEmail;
  constructor(public data: any) { }
}


export type FormStatusActions =
  LoadInitFormStatusState
  | LoadFormStatusStateFail
  | FormStatusScreenErrorReset

  | LoadOpenFormCGState
  | LoadOpenFormCGStateSuccess
  | LoadClosedFormCGState
  | LoadClosedFormCGStateSuccess

  | LoadOpenFormPPState
  | LoadOpenFormPPStateSuccess
  | LoadClosedFormPPState
  | LoadClosedFormPPStateSuccess

  | LoadOpenFormESState
  | LoadOpenFormESStateSuccess
  | LoadClosedFormESState
  | LoadClosedFormESStateSuccess

  | CloseRequest
  | ComposeEmail





  // LoadOpenFormCIState = '[FormStatus] Load Open FormCI State',
  // LoadOpenFormCIStateSuccess = '[FormStatus] Load Open FormCI State Success',
  // LoadClosedFormCIState = '[FormStatus] Load Closed FormCI State',
  // LoadClosedFormCIStateSuccess = '[FormStatus] Load Closed FormCI State Success',
  // LoadOpenFormFOState = '[FormStatus] Load Open FormFO State',
  // LoadOpenFormFOStateSuccess = '[FormStatus] Load Open FormFO State Success',
  // LoadClosedFormFOState = '[FormStatus] Load Closed FormFO State',
  // LoadClosedFormFOStateSuccess = '[FormStatus] Load Closed FormFO State Success',


  // | LoadOpenFormCIState
  // | LoadOpenFormCIStateSuccess
  // | LoadOpenFormFOState
  // | LoadOpenFormFOStateSuccess
  // | LoadClosedFormCIState
  // | LoadClosedFormCIStateSuccess
  // | LoadClosedFormFOState
  // | LoadClosedFormFOStateSuccess


  // export class LoadOpenFormCIState implements Action {
  //   readonly type = FormStatusActionTypes.LoadOpenFormCIState;
  // }

  // export class LoadOpenFormCIStateSuccess implements Action {
  //   readonly type = FormStatusActionTypes.LoadOpenFormCIStateSuccess;
  //   constructor(public payload: IFormStatus) { }
  // }

  // export class LoadOpenFormFOState implements Action {
  //   readonly type = FormStatusActionTypes.LoadOpenFormFOState;
  // }

  // export class LoadOpenFormFOStateSuccess implements Action {
  //   readonly type = FormStatusActionTypes.LoadOpenFormFOStateSuccess;
  //   constructor(public payload: IFormStatus) { }
  // }

  // export class LoadClosedFormCIState implements Action {
  //   readonly type = FormStatusActionTypes.LoadClosedFormCIState;
  // }

  // export class LoadClosedFormCIStateSuccess implements Action {
  //   readonly type = FormStatusActionTypes.LoadClosedFormCIStateSuccess;
  //   constructor(public payload: IFormStatus) { }
  // }

  // export class LoadClosedFormFOState implements Action {
  //   readonly type = FormStatusActionTypes.LoadClosedFormFOState;
  // }

  // export class LoadClosedFormFOStateSuccess implements Action {
  //   readonly type = FormStatusActionTypes.LoadClosedFormFOStateSuccess;
  //   constructor(public payload: IFormStatus) { }
  // }